const _field = field => state => state[field]
const _value = (field, id) => state => state[field][state[id]]

export { _field, _value }
